/* Aanpassingen op de productpagina die niet met CSS kunnen.
   Alles is weergave: er wordt niets aan de slider, het formulier of het
   toevoegen aan de winkelwagen zelf veranderd. */
(function () {

  /* 1. Teller "1 / 10" linksonder in het beeld.
     Flickity zit in dit thema in een bundel en staat niet als
     window.Flickity klaar, dus we lezen de actieve slide uit de class
     is-selected in plaats van uit de API. */
  function teller(box) {
    if (box.querySelector('.qtl-gallery-count')) return true;
    var slider = box.querySelector('.flickity-slider');
    if (!slider) return false;
    var cellen = slider.children;
    if (cellen.length < 2) return true;

    var el = document.createElement('div');
    el.className = 'qtl-gallery-count';
    var getal = document.createElement('span');
    getal.className = 'qtl-count-num';
    el.appendChild(getal);
    box.appendChild(el);

    function bijwerken() {
      var i = 0;
      for (var n = 0; n < cellen.length; n++) {
        if (cellen[n].classList.contains('is-selected')) { i = n; break; }
      }
      getal.textContent = (i + 1) + ' / ' + cellen.length;
    }
    bijwerken();
    new MutationObserver(bijwerken).observe(slider, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    return true;
  }

  /* 2. Modelinfo naast de teller in het beeld.
     Het thema zet op mobiel een eigen badge IN elke slide; die schuift mee
     bij het swipen. Die is via CSS verborgen. Onze versie hangt in de
     teller, buiten de slider, en staat dus stil.
     De tekst zelf komt uit de rechterkolom, die we daar verbergen. */
  function modelinfo(box) {
    var bronnen = document.querySelectorAll('.form__width .product_single_tekst_rule');
    if (!bronnen.length) return;
    var tekst = '';
    for (var i = 0; i < bronnen.length; i++) {
      var t = (bronnen[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t && !tekst) tekst = t;
      bronnen[i].classList.add('qtl-verborgen');
    }
    if (!tekst) return;

    /* Niet als los kind aan de galerij hangen: Flickity scant zijn
       container opnieuw en maakt er dan een slide van. */
    var houder = box.querySelector('.qtl-gallery-count');
    if (!houder || houder.querySelector('.qtl-count-model')) return;
    var el = document.createElement('span');
    el.className = 'qtl-count-model';
    el.textContent = tekst;
    houder.appendChild(el);
  }

  /* 3. Prijs achter de knoptekst: "ADD TO CART · €99,99".
     De prijs komt uit .product__price en loopt dus mee met de variant.
     Het thema mag de knoptekst blijven herschrijven (naar SOLD OUT
     bijvoorbeeld): dan zetten we ons stukje er opnieuw achter. */
  function knopprijs() {
    var tekst = document.querySelector('.form__width .add--cart .btn__text');
    var prijsEl = document.querySelector('.form__width .product__price');
    if (!tekst || !prijsEl) return false;

    function zet() {
      var m = (prijsEl.textContent || '').match(/[€$£]\s?[\d.,]+/);
      if (!m) return;
      var span = tekst.querySelector('.qtl-btn-price');
      if (!span) {
        span = document.createElement('span');
        span.className = 'qtl-btn-price';
        tekst.appendChild(span);
      }
      var nieuw = ' · ' + m[0];
      if (span.textContent !== nieuw) span.textContent = nieuw;
    }
    zet();
    new MutationObserver(zet).observe(tekst, { childList: true, characterData: true, subtree: true });
    new MutationObserver(zet).observe(prijsEl, { childList: true, characterData: true, subtree: true });
    return true;
  }

  /* 4. Size quiz boven de maatkeuze.
     De widget heeft twee knoppen: button.qsq-open ("What is my size?")
     zolang er niets is ingevuld, en .qsq-mysize-wrap ("Your size is S")
     daarna. Allebei staan ze onder de ATC-knop. We gebruiken alleen de
     opener, altijd op dezelfde plek en met dezelfde tekst, en verbergen
     de resultaatknop. */
  function sizequiz() {
    var maat = document.querySelector('.form__width .selector-wrapper.Size');
    if (!maat) return false;

    /* Op petten, tassen, zonnebrillen en sokken laadt theme.liquid de
       maatwijzer bewust niet. Dan valt er hier ook niets te verplaatsen,
       en moet start() niet tien seconden blijven zoeken naar een knop
       die nooit komt. QSQ_PRODUCT wordt alleen gezet als de quiz hoort
       te draaien, dus daar kunnen we op afgaan. */
    if (!window.QSQ_PRODUCT) return true;

    /* Het thema toont OF de uitnodiging (.qsq-open) OF, zodra de bezoeker
       de quiz heeft ingevuld, de uitkomst (.qsq-mysize) - en die laatste
       zet het ergens anders neer, onderin bij de knoppen in
       .product__submit__buttons. Eerder keken we alleen naar .qsq-open.
       Zodra iemand dus een maat had, viel deze functie eruit en verdween
       de hele regel boven de maatkeuze. Nu pakken we allebei. */
    /* De widget wisselt zijn eigen knop om zodra er een maat is. Daarbij
       kan onze houder leeg achterblijven en dat is een zichtbaar gat.
       Ruim lege houders op voordat we opnieuw opbouwen. */
    var houders = document.querySelectorAll('.qtl-quiz-boven');
    for (var h = 0; h < houders.length; h++) {
      if (!houders[h].children.length) houders[h].parentNode.removeChild(houders[h]);
    }

    var knop = document.querySelector('.qtl-quiz-boven .qsq-mysize')
            || document.querySelector('.qtl-quiz-boven .qsq-open')
            || document.querySelector('.qsq-mysize')
            || document.querySelector('.qsq-open');
    if (!knop) return false;

    var heeftUitkomst = knop.classList.contains('qsq-mysize');

    var houder = knop.parentElement;
    if (!houder || !houder.classList.contains('qtl-quiz-boven')) {
      houder = document.createElement('div');
      houder.className = 'qtl-quiz-boven';
      knop.parentNode.insertBefore(houder, knop);
      houder.appendChild(knop);
    }

    /* Bij een uitkomst laten we de tekst van het thema staan, dus
       "Your size is M". Het liniaal-icoon en het vraagtekentje gaan met
       CSS weg. Alleen bij de uitnodiging schrijven we zelf de korte tekst,
       want die knop heet in het thema iets langers. */
    if (!heeftUitkomst && !knop.querySelector('.qtl-quiz-label')) {
      knop.textContent = '';
      var label = document.createElement('span');
      label.className = 'qtl-quiz-label';
      label.textContent = 'Find your size';
      knop.appendChild(label);
    }

    /* Bij setproducten (bundels uit de Shopify-app) staan er twee
       maatkeuzes, elk met een eigen label ervoor: "Select ... Size".
       Zonder correctie belandt de quiz tussen dat label en de vakjes.
       Daarom lopen we eerst terug over eventuele labels, zodat hij
       boven het hele blok komt te staan. */
    var doel = maat;
    var vorige = doel.previousElementSibling;
    while (vorige && /legend|option-name|selector-label/i.test(String(vorige.className || ''))) {
      doel = vorige;
      vorige = doel.previousElementSibling;
    }

    if (doel.previousElementSibling !== houder) {
      doel.parentNode.insertBefore(houder, doel);
    }

    /* Wat er van het oorspronkelijke blok overblijft is een leeg omhulsel.
       Dat verbergen we, maar pas hier: de houder zit op dit moment buiten
       het omhulsel, dus we verbergen nooit per ongeluk onze eigen knop. */
    var resten = document.querySelectorAll('.qsq-mysize-wrap');
    for (var i = 0; i < resten.length; i++) {
      if (!resten[i].contains(knop)) resten[i].classList.add('qtl-quiz-verborgen');
    }
    return true;
  }

  /* 4b. Uitkomst meteen laten zien.
     De maatwijzer bouwt zijn eigen knop "Your size is M" pas bij de
     volgende paginalading. Tot die tijd bleef er "Find your size" staan
     terwijl de bezoeker net een maat had gekregen, en dat leest als een
     quiz die niets deed. We nemen de uitkomst daarom direct over uit het
     resultaatscherm: .qsq-rsize is de grote letter in de modal.
     Bij de volgende lading neemt de knop van het thema het over, met
     dezelfde tekst, dus er springt niets. */
  function quizUitkomstTonen() {
    var bron = document.querySelector('.qsq-rsize');
    if (!bron) return;
    var maat = (bron.textContent || '').trim();
    if (!maat || maat.length > 6 || /\s/.test(maat)) return;
    var label = document.querySelector('.qtl-quiz-boven .qtl-quiz-label');
    if (!label) return;
    var wens = 'Your size is <b>' + maat + '</b>';
    if (label.innerHTML !== wens) label.innerHTML = wens;
  }

  /* 4c. Modelmaat over de eerste foto.
     Op mobiel staat die in de tellerbalk van de carrousel. Op desktop is er
     geen carrousel meer maar een raster van twee foto's naast elkaar, en dus
     ook geen tellerbalk. Het thema vult zijn eigen .model-size-text alleen
     vanuit de carrousel, dus daar blijft hij leeg. We zetten de tekst er zelf
     neer, en alleen op de eerste foto: op de andere voegt hij niets toe en
     leidt hij af van het beeld. De tekst komt uit window.QTL_MODEL, dat
     theme.liquid op elke productpagina meegeeft. Zichtbaar maken doet de CSS,
     die pas vanaf 750px aanslaat. */
  function modelOpFoto() {
    var tekst = String(window.QTL_MODEL || '').trim();
    if (!tekst) return;
    var box = document.querySelector('[data-product-slideshow]');
    if (!box) return;
    /* Op de TWEEDE foto. Daar staat bij Quotrell het model op ware grootte,
       terwijl foto 1 meestal een plat vooraanzicht of een rugshot is. Het is
       ook de foto waar de iconen (Organic Cotton, Heavyweight, Oversized Fit)
       overheen zweven, dus alle pasvorm-informatie staat bij elkaar.
       Heeft een product maar een foto, dan valt hij terug op de eerste. */
    var slides = box.querySelectorAll('.product__slide');
    var doel = slides[1] || slides[0];
    if (!doel) return;

    /* Zat hij eerder op een andere foto, dan halen we hem daar weg. Anders
       blijft er bij een wissel van variant een tweede tekst achter. */
    var bestaand = box.querySelectorAll('.qtl-model-op-foto');
    for (var i = 0; i < bestaand.length; i++) {
      if (bestaand[i].parentNode !== doel) bestaand[i].parentNode.removeChild(bestaand[i]);
    }
    if (doel.querySelector('.qtl-model-op-foto')) return;

    var el = document.createElement('div');
    el.className = 'qtl-model-op-foto';
    el.textContent = tekst;
    doel.appendChild(el);
  }

  /* 5. Zoomknop naar de balk linksonder, zodat hij rechts op dezelfde
     lijn staat als de teller in plaats van halverwege te zweven. Hij gaat
     in die balk omdat Flickity losse kinderen als slide oppikt. */
  function zoomknop(box) {
    var bar = box.querySelector('.qtl-gallery-count');
    var zoom = document.querySelector('.zoom-in-icon-mobile');
    if (!bar || !zoom) return;
    if (zoom.parentElement === bar) return;
    zoom.classList.add('qtl-zoom');
    bar.appendChild(zoom);
  }

  /* 6. Kop boven de upsell in de winkelwagen.
     Zit de klant nog onder de drempel voor gratis verzending, dan wordt
     "Complete the Look" een concrete reden om iets bij te leggen. Het
     bedrag lezen we uit de voortgangsbalk die het thema zelf al vult,
     zodat we niet een tweede berekening naast de bestaande zetten die
     uit elkaar kan lopen. Is de drempel gehaald, dan blijft de gewone
     kop staan. */
  function upsellKop() {
    var koppen = document.querySelectorAll('.upsellproduct_title');
    if (!koppen.length) return;
    /* De balk bevat BEIDE teksten tegelijk in de code: .qtl-msg--default
       ("nog X te gaan") en .qtl-msg--success ("je hebt het gehaald"). Het
       thema verbergt er telkens een. Lees dus alleen de zichtbare, anders
       krijg je "Add €0,00 for free shipping" zodra de drempel gehaald is. */
    var def = document.querySelector('.drawer__message.free-shipping .qtl-msg--default');
    var zichtbaar = def && getComputedStyle(def).display !== 'none';
    var m = zichtbaar
      ? (def.textContent || '').replace(/\s+/g, ' ').match(/([€$£]\s?[\d.,]+)\s*away from/i)
      : null;

    /* is de drempel gehaald? dan toont het thema de success-variant */
    var suc = document.querySelector('.drawer__message.free-shipping .qtl-msg--success');
    var gehaald = suc && getComputedStyle(suc).display !== 'none';

    /* en het bedrag moet ook echt boven nul liggen */
    if (m) {
      var getal = parseFloat(
        m[1].replace(/[^\d.,]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')
      );
      if (!(getal > 0)) m = null;
    }

    for (var i = 0; i < koppen.length; i++) {
      var kop = koppen[i];
      if (!kop.getAttribute('data-qtl-basis')) {
        kop.setAttribute('data-qtl-basis', (kop.textContent || '').trim());
      }
      var basis = kop.getAttribute('data-qtl-basis');
      var gewenst;
      if (m) {
        gewenst = 'Add ' + m[1].replace(/\s/g, '') + ' for free shipping';
      } else if (gehaald) {
        gewenst = "You've got free shipping";
      } else {
        gewenst = basis;
      }
      if ((kop.textContent || '').trim() !== gewenst) kop.textContent = gewenst;
    }
  }

  /* 6. Bewaar-icoon verticaal op de productnaam.
     Het icoon staat absoluut in de kaart met een vaste top die per
     sectie verschilt; op de homepage kwam het daardoor tussen de naam
     en de prijs te hangen. De hoogte van de naamregel is per sectie
     anders, dus dit kan CSS niet uitrekenen. We meten het een keer en
     zetten de top zo dat het icoon op het midden van de naam staat. */
  function bookmarksUitlijnen() {
    var kaarten = document.querySelectorAll('.product-item');
    for (var i = 0; i < kaarten.length; i++) {
      var k = kaarten[i];
      if (k.closest('.drawer--cart') || k.closest('upsell-product')) continue;
      var wl = k.querySelector('.wishlist-bookmark');
      var titel = k.querySelector('.product-item__title');
      if (!wl || !titel) continue;
      var kr = k.getBoundingClientRect();
      var tr = titel.getBoundingClientRect();
      var wr = wl.getBoundingClientRect();
      if (!tr.height || !wr.height) continue;
      var doel = Math.round(tr.top - kr.top + tr.height / 2 - wr.height / 2);
      if (wl.getAttribute('data-qtl-top') === String(doel)) continue;
      wl.style.top = doel + 'px';
      wl.setAttribute('data-qtl-top', String(doel));
    }
  }

  /* 7. Slider in de winkelwagen laten slepen bij de eerste keer openen.
     De drawer heeft een eigen sleepgebaar om te sluiten dat met
     JavaScript is gemaakt. touch-action houdt dat niet tegen, want dat
     werkt alleen tegen het scrollgedrag van de browser zelf. Daarom
     stoppen we de aanraking bij de rij zelf, zodat de drawer hem niet
     meer ziet. Passief, dus we blokkeren het scrollen niet.
     De drawer bouwt zichzelf opnieuw op na elke wijziging, vandaar de
     markering zodat we niet dubbel koppelen. */
  function upsellSlepen() {
    var rijen = document.querySelectorAll('.mini-cart__recommendations-inner .cart-item-wrapper');
    for (var i = 0; i < rijen.length; i++) {
      var rij = rijen[i];
      if (rij.getAttribute('data-qtl-sleep')) continue;
      rij.setAttribute('data-qtl-sleep', '1');
      var stop = function (e) { e.stopPropagation(); };
      rij.addEventListener('touchstart', stop, { passive: true });
      rij.addEventListener('touchmove', stop, { passive: true });
      rij.addEventListener('pointerdown', stop, { passive: true });
    }
  }


  /* 9. Meten.
     Het thema stuurt zelf geen gebeurtenis als de winkelwagenla opengaat,
     als iemand op een productkaart klikt of als de maatwijzer gebruikt
     wordt. Precies de drie dingen die we opnieuw hebben gebouwd, waren
     dus onzichtbaar in GA4. Hieronder sturen we ze alsnog.

     De Google-tag in theme.liquid staat alleen op Google Ads (AW-...).
     GA4 loopt via de Shopify-koppeling en die zit in een afgeschermd
     kadertje waar we niet bij kunnen. Daarom hangen we GA4 er hier zelf
     bij, met send_page_view uit, zodat we ALLEEN deze drie gebeurtenissen
     sturen en geen paginaweergaves of aankopen dubbel tellen.

     Alles staat in try/catch: mocht Google geblokkeerd zijn door een
     adblocker, dan mag dat de winkel niet raken. */
  /* Let op met deze code: op quotrell.com staan DRIE GA4-tags. G-795FDEBDXT
     en G-LXJ9YGL415 horen bij andere properties. Alleen G-XZNTT3RBM0 is
     property 398916323, de enige die het dashboard uitleest. Nagemeten op
     26-09-2026 met een proefgebeurtenis per tag tegen het realtime-rapport.
     De sessiecookie _ga_XZNTT3RBM0 wordt al door de Shopify-koppeling
     bijgehouden, dus onze gebeurtenissen haken aan op de lopende sessie en
     tellen geen extra sessies mee. */
  var GA4 = 'G-XZNTT3RBM0';

  function stuur(naam, gegevens) {
    try {
      if (typeof window.gtag !== 'function') return;
      var d = gegevens || {};
      d.send_to = GA4;
      window.gtag('event', naam, d);
    } catch (e) {}
  }

  function metenKlaar() {
    try {
      if (typeof window.gtag !== 'function') return false;
      if (window.__qtlGA4) return true;
      window.gtag('config', GA4, { send_page_view: false });
      window.__qtlGA4 = true;
      return true;
    } catch (e) { return false; }
  }

  /* Welke lijst staat de bezoeker te bekijken. Gaat mee met select_item
     zodat je later kan zien welke collectie goed doorklikt. */
  function lijstnaam() {
    try {
      var p = location.pathname;
      if (p === '/') return 'homepage';
      var m = p.match(/^\/collections\/([^\/]+)/);
      if (m) return 'collection: ' + m[1];
      if (p.indexOf('/products/') === 0) return 'product page';
      return p;
    } catch (e) { return ''; }
  }

  /* a. Klik op een productkaart. Delegatie op document, want de kaarten
        worden bij filteren opnieuw opgebouwd. */
  function metenKaarten() {
    if (window.__qtlKaartMeter) return;
    window.__qtlKaartMeter = true;
    document.addEventListener('click', function (e) {
      try {
        var kaart = e.target.closest && e.target.closest('[data-product-grid-item]');
        if (!kaart) return;
        if (!e.target.closest('a')) return;           // alleen echte doorkliks
        if (e.target.closest('[data-product-quickbuy], .quick-add, .wishlist-bookmark')) return;
        var titel = kaart.querySelector('.product-item__title');
        var id = kaart.getAttribute('data-product-id')
              || (kaart.id || '').replace('product-item---', '');
        stuur('select_item', {
          item_list_name: lijstnaam(),
          items: [{ item_id: String(id || ''), item_name: titel ? titel.textContent.trim() : '' }],
        });
      } catch (err) {}
    }, true);
  }

  /* b. Winkelwagenla gaat open. Het thema zet daar een class op in plaats
        van de la aan en uit te hangen, dus we kijken naar die class.
        Alleen de overgang dicht -> open telt, anders vuurt hij bij elke
        andere classwijziging opnieuw. */
  function metenDrawer() {
    if (window.__qtlDrawerMeter) return;
    var la = document.getElementById('cart-drawer') || document.querySelector('[data-cart-drawer]');
    if (!la) return;
    window.__qtlDrawerMeter = true;
    var open = function () {
      var c = la.className || '';
      return /\bis-(open|active|visible)\b/.test(c);
    };
    var vorige = open();
    new MutationObserver(function () {
      var nu = open();
      if (nu && !vorige) {
        var regels = document.querySelectorAll('[data-cart-drawer-body] .cart-item, [data-cart-drawer-body] .cart-item-wrapper');
        stuur('qtl_drawer_open', { aantal_regels: regels.length });
      }
      vorige = nu;
    }).observe(la, { attributes: true, attributeFilter: ['class'] });
  }

  /* c. Maatwijzer. Openen en, als er een maat uit komt, welke.
        .qsq-open is de knop, .qsq-mysize-wrap is het vakje met "Your size is L"
        dat we met CSS verbergen tot hij gevuld is. */
  function metenQuiz() {
    if (!window.__qtlQuizMeter) {
      window.__qtlQuizMeter = true;
      document.addEventListener('click', function (e) {
        try {
          if (e.target.closest && e.target.closest('.qsq-open')) {
            stuur('qtl_quiz_open', { item_list_name: lijstnaam() });
          }
        } catch (err) {}
      }, true);
    }
    /* Het uitkomstvak bestaat pas nadat de quiz een maat teruggeeft, en het
       kan meteen gevuld verschijnen. Dan is er geen verandering te zien en
       zou een gewone waarnemer niets merken. Daarom sturen we bij het
       aanhaken al door wat er staat, en daarna alleen nog echte wijzigingen.
       __qtlQuizUit onthoudt de laatste uitkomst zodat hetzelfde antwoord
       niet twee keer geteld wordt als de widget zichzelf opnieuw opbouwt. */
    /* De uitkomst staat nu in onze eigen regel, niet meer in het
       omhulsel van het thema: dat is na het verplaatsen leeg. */
    var vak = document.querySelector('.qtl-quiz-boven') || document.querySelector('.qsq-mysize-wrap');
    if (!vak || vak.getAttribute('data-qtl-meter')) return;
    vak.setAttribute('data-qtl-meter', '1');

    var meld = function (tekst) {
      var t = (tekst || '').trim();
      if (!t || t === window.__qtlQuizUit) return;
      if (/find your size/i.test(t)) return;   // dat is de uitnodiging, geen uitkomst
      window.__qtlQuizUit = t;
      stuur('qtl_quiz_result', { uitkomst: t.slice(0, 60) });
    };

    meld(vak.textContent);
    new MutationObserver(function () {
      meld(vak.textContent);
    }).observe(vak, { childList: true, subtree: true, characterData: true });
  }

  /* De Google-tag laadt met async, dus hij is er bij het uitvoeren van dit
     bestand nog niet. Daarom kort blijven proberen en dan pas beginnen. */
  function metenStarten() {
    var pogingen = 0;
    var t = setInterval(function () {
      if (metenKlaar()) {
        clearInterval(t);
        metenKaarten();
        metenDrawer();
        metenQuiz();
        /* Eigen waarnemer voor de meters. De la en het uitkomstvak van de
           quiz verschijnen pas later in de pagina, en soms pas na een
           herbouw door de widget. Dit mag niet afhangen van quizBewaken:
           die heeft een bezig-vlag voor de opmaak en als daar ooit iets
           misgaat zou de meting stilvallen zonder dat iemand het ziet.
           Beide functies slaan zichzelf over als ze al hangen, dus dit
           kost vrijwel niets. */
        var wacht = false;
        new MutationObserver(function () {
          if (wacht) return;
          wacht = true;
          /* Bewust setTimeout en geen requestAnimationFrame: die staat stil
             zodra het tabblad naar de achtergrond gaat. Voor opmaak geeft
             dat niet, maar een meting die alleen loopt als je staat te
             kijken is geen meting. */
          setTimeout(function () {
            try { metenDrawer(); metenQuiz(); } catch (e) {}
            wacht = false;
          }, 0);
        }).observe(document.body, { childList: true, subtree: true });
      } else if (++pogingen > 40) {
        clearInterval(t);
      }
    }, 250);
  }

  function start() {
    var box = document.querySelector('[data-product-slideshow]');
    if (!box) return false;
    var a = teller(box);
    modelinfo(box);
    var b = knopprijs();
    var c = sizequiz();
    quizUitkomstTonen();
    modelOpFoto();
    zoomknop(box);
    upsellKop();
    bookmarksUitlijnen();
    upsellSlepen();
    return a && b && c;
  }

  /* De quiz-widget laadt zichzelf in en kan zich daarna opnieuw plaatsen.
     Op een telefoon gebeurt dat later dan op een snelle desktop, waardoor
     een eenmalige verplaatsing te vroeg kwam. Daarom blijven we kijken.
     Dit veroorzaakt geen lus: we doen alleen iets als de knop niet al op
     de goede plek staat. */
  function quizBewaken() {
    var bezig = false;
    new MutationObserver(function () {
      if (bezig) return;
      bezig = true;
      /* setTimeout en geen requestAnimationFrame: die staat stil zodra het
         tabblad naar de achtergrond gaat, en op een telefoon gebeurt dat
         voortdurend. Wie tijdens de maatwijzer even wegklikt en terugkomt,
         kreeg anders een lege regel te zien waar de knop hoort te staan. */
      setTimeout(function () {
        sizequiz();
        quizUitkomstTonen();
        modelOpFoto();
        upsellKop();
        bookmarksUitlijnen();
        upsellSlepen();
        bezig = false;
      }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (!start()) {
    var pogingen = 0;
    var t = setInterval(function () {
      if (start() || ++pogingen > 40) clearInterval(t);
    }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bookmarksUitlijnen);
  } else {
    bookmarksUitlijnen();
  }
  addEventListener('load', bookmarksUitlijnen);

  if (document.body) quizBewaken();
  else document.addEventListener('DOMContentLoaded', quizBewaken);

  /* Meten staat los van start(): dat vraagt om een productslider en die
     bestaat alleen op de productpagina, terwijl de winkelwagenla en de
     productkaarten juist overal staan. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', metenStarten);
  } else {
    metenStarten();
  }
  addEventListener('load', function () { metenDrawer(); metenQuiz(); });
})();
